import { widgetComponents } from '@/pages/CustomDashboard/Widgets/registry';
import * as React from 'react';

export function Widget({ widget }) {
    const Component = widgetComponents[widget.type] || (() => <div>Unknown widget</div>);

    return (
        <div className="tw-w-full tw-h-full tw-p-2">
            <Component widget={widget}/>
        </div>
    );
}
